// export DsfRow12 from "./row_1_2.vue";
// export DsfRow from "./row.vue";
// export DsfFlexColumn from "./column.vue";
// export DsfRowHalf from "./rowHalf.js";
// export DsfCol from "./col.vue";
// export DsfRow13 from "./row_1_3.vue";
// export DsfTable from "./table.vue";
// export DsfTableRow from "./tableRow.vue";
// export DsfTableCell from "./tableCell.vue";
// export DsfViewPart from "./viewPart.vue";
// export DsfMultiRouteView from "./multiRouteView.js";
// export DsfDragGrid from './dragGrid.vue'
export const DsfVirtualScroll = dsf.defineLazyComponent("DsfVirtualScroll", () =>
  require("./virtualScroll.vue")
);

// export const DsfDragGrid = dsf.defineLazyComponent("DsfDragGrid", () =>
//   import(/*webpackChunkName:"platform_pc_layout"*/ "./dragGrid.vue")
// );
export const DsfMultiRouteView = dsf.defineAsyncComponent("DsfMultiRouteView", () =>
  import(/*webpackChunkName:"platform_pc_layout"*/ "./multiRouteView.js")
);

export const DsfViewPart = dsf.defineAsyncComponent("DsfViewPart", () =>
  import(/*webpackChunkName:"platform_pc_layout"*/ "./viewPart.vue")
);
export const DsfCol = dsf.defineAsyncComponent("DsfCol", () =>
  import(/*webpackChunkName:"platform_pc_layout"*/ "./col.vue")
);

export const DsfRow = dsf.defineAsyncComponent("DsfRow", () => {
  return dsf.requestAsyncComponents([DsfCol]).then(() => {
    return import(/*webpackChunkName:"platform_pc_layout"*/ "./row.vue");
  });
});

export const DsfRow12 = dsf.defineAsyncComponent("DsfRow12", () => {
  return dsf.requestAsyncComponents([DsfCol]).then(() => {
    return import(/*webpackChunkName:"platform_pc_layout"*/ "./row_1_2.vue");
  });
});

export const DsfRow13 = dsf.defineAsyncComponent("DsfRow13", () => {
  return dsf.requestAsyncComponents([DsfCol]).then(() => {
    return import(/*webpackChunkName:"platform_pc_layout"*/ "./row_1_3.vue");
  });
});

export const DsfFlexColumn = dsf.defineAsyncComponent("DsfFlexColumn", () =>
  import(/*webpackChunkName:"platform_pc_layout"*/ "./column.vue")
);
export const DsfRowHalf = dsf.defineAsyncComponent("DsfRowHalf", () => {
  return dsf.requestAsyncComponents([DsfRow]).then(() => {
    return import(/*webpackChunkName:"platform_pc_layout"*/ "./rowHalf.js");
  });
});

export const DsfTableRow = dsf.defineAsyncComponent("DsfTableRow", () =>
  import(/*webpackChunkName:"platform_pc_layout"*/ "./tableRow.vue")
);
export const DsfTableCell = dsf.defineAsyncComponent("DsfTableCell", () =>
  import(/*webpackChunkName:"platform_pc_layout"*/ "./tableCell.vue")
);

export const DsfTable = dsf.defineAsyncComponent("DsfTable", () => {
  return dsf.requestAsyncComponents([DsfTableRow, DsfTableCell]).then(() => {
    return import(/*webpackChunkName:"platform_pc_layout"*/ "./table.vue");
  });
});

export const DsfFastFormLayout = dsf.defineAsyncComponent("DsfFastFormLayout", () =>
  import(/*webpackChunkName:"platform_pc_layout"*/ "./fastFormLayout.vue")
);

export const DsfGridLayout = dsf.defineAsyncComponent("DsfGridLayout", () =>
  import(/*webpackChunkName:"platform_pc_layout"*/ "./grid.vue")
);

export const DsfFlexibleBox = dsf.defineAsyncComponent("DsfFlexibleBox", () =>
  import(/*webpackChunkName:"platform_pc_layout"*/ "./flexibleBox.vue")
);

export const DsfLazyBox = dsf.defineAsyncComponent("DsfLazyBox", () =>
  import(/*webpackChunkName:"platform_pc_layout"*/ "./lazybox.vue")
);
export const DsfCollapse = dsf.defineAsyncComponent("DsfCollapse", () =>
  import(/*webpackChunkName:"platform_pc_layout"*/ "./collapse.vue")
);
export const DsfSection = dsf.defineAsyncComponent("DsfSection", () =>
  import(/*webpackChunkName:"platform_pc_layout"*/ "./section.vue")
);
export const DsfIframe = dsf.defineAsyncComponent("DsfIframe", () =>
  import(/*webpackChunkName:"platform_pc_layout"*/ "./iframe.vue")
);
